// Stage 3, Performance Report. Presentational only.
//
// The mark here is a copy of the diagnostic's. The container passes the
// diagnostic's result when the two disagree, so one number appears on screen.

import React from 'react';
import {
  Caveat, DetailBlock, Heading, Prose, ScoreResult, StrengthList,
} from './TaraFeedbackBlocks';

// A promised set of three. A null value renders "Not assessed" rather than an
// omitted row, because a missing row reads as a category that does not exist.
const TUTOR_ROWS = [
  ['clear_argumentation', 'Clear argumentation'],
  ['structure_and_cohesion', 'Structure and cohesion'],
  ['concision', 'Concision'],
];

export default function TaraPerformanceReport({ feedback, spans }) {
  if (!feedback) return null;
  const tutors = feedback.what_tutors_look_for;

  return (
    <div className="tara-fb-body">
      <ScoreResult result={feedback.result} />
      <Prose>{feedback.performance_summary}</Prose>

      {Array.isArray(feedback.what_you_already_do_well)
        && feedback.what_you_already_do_well.length ? (
          <section className="tara-fb-group">
            <Heading>What you already do well</Heading>
            <StrengthList
              items={feedback.what_you_already_do_well}
              spans={spans}
              whyKey="why_it_matters"
            />
          </section>
        ) : null}

      {feedback.what_currently_limits_the_argument ? (
        <section className="tara-fb-group">
          <Heading>What currently limits the argument</Heading>
          <DetailBlock value={feedback.what_currently_limits_the_argument} />
        </section>
      ) : null}

      {feedback.next_reasoning_ability_to_develop ? (
        <section className="tara-fb-group">
          <Heading>What to develop next</Heading>
          <DetailBlock value={feedback.next_reasoning_ability_to_develop} />
        </section>
      ) : null}

      {feedback.upgraded_judgement_architecture ? (
        <section className="tara-fb-group">
          <Heading>A stronger shape for your judgement</Heading>
          <DetailBlock value={feedback.upgraded_judgement_architecture} />
        </section>
      ) : null}

      {tutors && typeof tutors === 'object' ? (
        <section className="tara-fb-group">
          <Heading>What tutors look for</Heading>
          {TUTOR_ROWS.map(([key, label]) => (
            <div key={key} className="tara-fb-tutor">
              <span className="tara-fb-tutor-name">{label}</span>
              {tutors[key]
                ? <span className="tara-fb-tutor-note">{tutors[key]}</span>
                : <span className="tara-fb-trait-none">Not assessed</span>}
            </div>
          ))}
        </section>
      ) : null}

      {feedback.next_test ? (
        <section className="tara-fb-group">
          <Heading>Your next test</Heading>
          <DetailBlock value={feedback.next_test} />
        </section>
      ) : null}

      <Prose className="tara-fb-soft">{feedback.longitudinal_note}</Prose>
      <Caveat>{feedback.limitations_note}</Caveat>
    </div>
  );
}
